import { React, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { SIGN_UP } from "../helpers/api"
import { SHA_Encryption } from "../helpers/token"

function SignUp() {
    const navigate = useNavigate();
    const [data, setData] = useState({
        username: "",
        email: "",
        password1: "",
        password2: "",
        phone: "",
    })


    const usersignup = async (e) => {
        try {
            console.log(data);
            if ((data.phone).length != 11) return alert("Contact number should have 11 characters")
            if (data.password1 === data.password2) {
                const payload = {
                    username: (data.username).toLowerCase(),
                    email: data.email,
                    password: SHA_Encryption(data.password2),
                    phone: data.phone
                }
                console.log(payload);
                const response = await SIGN_UP(payload)
                console.log("response", response);
                if (response.success) {
                    alert("You are registered successfully")
                    navigate("/sign-in")
                }
                else {
                    alert(response.message)
                }

            }
            else {
                alert("passowrd mismatched")
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const handleUsername = (event) => {
        setData({ ...data, username: event.target.value })
    }

    const handleContact = (event) => {
        setData({ ...data, phone: event.target.value })
    }

    const handleEmail = (event) => {
        setData({ ...data, email: event.target.value })
    }

    const handlePassword = (event) => {
        setData({ ...data, password1: event.target.value })
    }

    const handlePassword2 = (event) => {
        setData({ ...data, password2: event.target.value })
    }

    return (
        <>
            <section className='signup_sec'>
                <div className="container">
                    <div className="card jc-center">
                        <h3 className='mb-5'>Create Your Account</h3>
                        <div className="mb-3">
                            <label className="form-label mb-2">Username</label>
                            <input type="text" onChange={(e) => handleUsername(e)} className="form-control" value={data.username} placeholder='Enter here' />
                        </div>
                        <div className="mb-3">
                            <label className="form-label mb-2">Contact details</label>
                            <input type="number" className="form-control" onChange={(e) => handleContact(e)} value={data.contact} placeholder='Enter here' />
                        </div>
                        <div className="mb-3">
                            <label className="form-label mb-2">Email</label>
                            <input type="email" onChange={(e) => handleEmail(e)} value={data.email} className="form-control" placeholder='Enter here' />
                        </div>
                        <div className="mb-3">
                            <label className="form-label mb-2">Password</label>
                            <input onChange={(e) => handlePassword(e)} value={data.password1} type="password" className="form-control" placeholder='Enter here' />
                        </div>
                        <div className="mb-5">
                            <label className="form-label mb-2">Confirm Password</label>
                            <input onChange={(e) => handlePassword2(e)} value={data.password2} type="password" className="form-control" placeholder='Enter here' />
                        </div>
                        <div className="mb-3">
                            <button className="btn sign_btn" onClick={usersignup}>Sign Up</button>
                        </div>

                        <small>Already a User? &nbsp; <Link to="/sign-in"> Sign In</Link></small>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SignUp
